import React from "react";
const NavbarToggle = ({ toggleSideBar }) => {
  return (
    <nav className="nav">
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a
        href="#"
        onClick={toggleSideBar}
        className="nav-link nav-link-icon toggle-sidebar d-sm-inline d-ml-inline d-lg-none text-center "
      >
        <i className="material-icons">&#xE5D2;</i>
      </a>
    </nav>
  );
};

export default NavbarToggle;
